import { Col, Row } from "reactstrap";
import { Image, P } from "../../../../../../../AbstractElements";
import { dynamicImage, dynamicNumber } from "../../../../../../../Utils";
import { CommonProductSlideProp } from "../../../../../../../Types/EcommerceType";

const CommonProductSlide:React.FC<CommonProductSlideProp> = ({ data }) => {
  
  return (
    <Row className={`product-box align-items-center my-3 ${data.rowClass ? data.rowClass : ""}`}>
      <Col md="5" className="product-img">
        <Image className="img-fluid img-100 rounded-3" src={dynamicImage(`ecommerce/${data.image}`)} alt="" />
      </Col>
      <Col md="7" className="product-details text-start p-0 py-3">
        <span>
          {dynamicNumber(5).map((index) => (
            <i className="fa fa-star font-warning me-1" key={index}></i>
          ))}
        </span>
        <P className="mb-0">{data.title}</P>
        <div className="product-price">{data.text}</div>
      </Col>
    </Row>
  );
};

export default CommonProductSlide;
